import React from 'react';

/**
 * Slim welcome banner shown between the scanner CTA and feature grid.
 * Pulled out of Dashboard.jsx to keep the shell focused on orchestration.
 */
export default function WelcomeBanner() {
  return (
    <div className="bg-zinc-900 border border-zinc-800 rounded-lg p-6 mb-6">
      <h2 className="text-2xl font-bold text-white mb-2">
        Welcome to <span className="text-[#00D26A]">Flipping</span>{' '}
        <span className="text-[#FFD700]">Friends</span>!
      </h2>
      <p className="text-zinc-400">
        Start by scanning a barcode above. Here&apos;s what&apos;s coming next:
      </p>
    </div>
  );
}
